import type { SmartCropMode } from '@/api/generator';
import {
  MOBILE_IMAGE_WIDTH_OVERVIEW,
  DESKTOP_IMAGE_WIDTH_OVERVIEW,
  MOBILE_IMAGE_WIDTH_DETAIL,
  DESKTOP_IMAGE_WIDTH_DETAIL,
} from './utils';

// Vuetify VImg props that are actually used in the codebase
interface VImgProps {
  alt?: string;
  cover?: boolean;
  eager?: boolean;
  position?: string;
  contentClass?: any;
  gradient?: string;
  lazySrc?: string;
  maxWidth?: string | number;
  maxHeight?: string | number;
  rounded?: string | number | boolean;
  height?: string | number;
  width?: string | number;
  aspectRatio?: string | number;
  sizes?: string;
  srcset?: string;
}

// BaseImage specific props that extend VImg functionality
export interface BaseImageProps extends VImgProps {
  // Core image properties
  pictureId?: string | null;
  fallbackIcon?: string;

  // Responsive sizing (BaseImage specific)
  mobileWidth?: number;
  desktopWidth?: number;

  // Cropping and display (BaseImage specific)
  cropMode?: SmartCropMode;

  // Responsive images (BaseImage specific)
  generateSrcset?: boolean;
  // Multipliers for srcset generation (e.g., [1, 2, 3])
  srcsetSizes?: number[];

  // Styling (BaseImage specific)
  hideImageFrame?: boolean;

  // Interaction (BaseImage specific)
  tooltip?: string | null;
}

// Preset configurations for common use cases
interface ImagePreset {
  mobileWidth: number;
  desktopWidth: number;
  aspectRatio?: number;
  generateSrcset?: boolean;
  srcsetSizes?: number[];
}

export const IMAGE_PRESETS = {
  overview: {
    mobileWidth: MOBILE_IMAGE_WIDTH_OVERVIEW,
    desktopWidth: DESKTOP_IMAGE_WIDTH_OVERVIEW,
    aspectRatio: 1,
    generateSrcset: true,
    srcsetSizes: [1, 2, 3],
  },
  detail: {
    mobileWidth: MOBILE_IMAGE_WIDTH_DETAIL,
    desktopWidth: DESKTOP_IMAGE_WIDTH_DETAIL,
    aspectRatio: 1,
    generateSrcset: true,
    srcsetSizes: [1, 2, 3],
  },
} as const satisfies Record<string, ImagePreset>;
